import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useProductSelectSearch } from '@/hooks/useProductSelectSearch';
import type { ProductResponse } from '@/types/product';

export interface ProductSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onProductChange?: (product: ProductResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  name?: string;
}

/** Searchable product picker — server search by name, SKU, or barcode. */
export function ProductSelect({
  label = 'Product',
  value = '',
  onChange,
  onProductChange,
  placeholder = 'Search product by name or SKU…',
  disabled,
  className,
  required,
  error,
  name,
}: ProductSelectProps) {
  const { options, loading, searching, onSearchQuery, getProduct } = useProductSelectSearch({ value });

  const handleChange = (next: string) => {
    onChange?.(next);
    onProductChange?.(next ? getProduct(next) ?? null : null);
  };

  return (
    <div className={className}>
      <SearchableSelect
        label={label}
        name={name}
        required={required}
        error={error}
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        loading={loading}
        searching={searching}
        searchPlaceholder="Search by name, SKU, or barcode…"
        emptyMessage="No products found"
        filterLocally={false}
        onSearchQuery={onSearchQuery}
      />
    </div>
  );
}
